// extracted by mini-css-extract-plugin
export default {"row":"LanguageSelector_row__X5HxJ","title":"LanguageSelector_title__xEchU","buttonGroup":"LanguageSelector_buttonGroup__rGWUS"};